import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { captureDemoTripFromUrl } from './utils/demoHandoff';
import ErrorBoundary from './ErrorBoundary';

// Website demo handoff: must run BEFORE the app renders, because a logged-in
// user is redirected away from /login (dropping the ?trip= link) on first render.
captureDemoTripFromUrl();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
